import { render, staticRenderFns } from "./investmentAimManageDetail.vue?vue&type=template&id=4fa64a0e&scoped=true&"
import script from "./investmentAimManageDetail.vue?vue&type=script&lang=js&"
export * from "./investmentAimManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./investmentAimManageDetail.vue?vue&type=style&index=0&id=4fa64a0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa64a0e",
  null
  
)

export default component.exports